import './UploadDocs.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import FileUpload from '../atoms/FileUpload/FileUpload';
import FileUploadingInfo from '../atoms/FileUploadingInfo/FileUploadingInfo';
const UploadDocs = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "upload-docs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement(FileUpload, {
    title: props.fileUploadTitle,
    description: props.fileUploadDescription,
    dragNdropText: props.dragNdropText,
    uploadButtonLabel: props.uploadButtonLabel,
    onChange: props.onChange,
    onError: props.onError,
    maxSizeKb: props.maxSizeKb,
    maxSizeLabel: props.maxSizeLabel,
    supportedFormats: props.supportedFormats,
    supportedFormatsLabel: props.supportedFormatsLabel
  }), props.files && props.files.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "upload-docs__files-list"
  }, props.files.map((el, i) => /*#__PURE__*/React.createElement(FileUploadingInfo, {
    key: el.id,
    byteDict: "$value$ byte",
    isUploaded: el.isUploaded,
    isLoading: el.isLoading,
    kbDict: "$value$ KB",
    filename: el.filename,
    percent: el.percent,
    size: el.size,
    successMessage: props.successMessage,
    onDelete: props.onDelete ? () => props.onDelete && props.onDelete(el.id) : undefined,
    error: el.error
  }))))));
};
export default UploadDocs;
const StyledWrapper = _ref => {
  let {
    children,
    rtl
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c1pbdvkz";
const rtlStyles = "r1no258u";
const ltrStyles = "l1ssljic";